import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import {
    expressConfigurationReadySelector,
    telephonyProfilesSelector,
    isCreatingSelector,
    editionSelector
} from '../selectors/userSelectors';
import { expressConfigurationReady, getTelephonyRequest } from '../actions/userActions';
import ExpressConfiguration from '../components/ExpressConfiguration/ExpressConfiguration';

const mapStateToProps = createStructuredSelector({
    telephonyProfiles: telephonyProfilesSelector,
    ready: expressConfigurationReadySelector,
    isCreating: isCreatingSelector,
    edition: editionSelector
});

const mapDispatchToProps = {
    expressConfigurationReady,
    getTelephonyRequest
};

export default withTranslation(['common', 'validations', 'users'])(
    connect(mapStateToProps, mapDispatchToProps)(withRouter(ExpressConfiguration))
);
